export default {
    UPDATE_FOLDER: "UPDATE_FOLDER"
}
